const actionsFlow = [{
  action: 'submit',
  status: 'submitted'
}, {
  action: 'acknowledge',
  status: 'acknowledged'
}, {
  action: 'approve_one',
  status: 'approved_one'
}, {
  action: 'approve_two',
  status: 'approved_two'
}, {
  action: 'approve_three',
  status: 'approved_three'
}, {
  action: 'approve_four',
  status: 'approved_four'
}, {
  action: 'approve_five',
  status: 'approved_five'
}];


const getReportNextAction = (report) => {
  let currentActionIndex = actionsFlow.findIndex(af => af.status === report.status);
  if(currentActionIndex < 0) {
    return null;
  }

  let actionConfig = report.signFlow[report.type];

  for(let i = currentActionIndex + 1; i < actionsFlow.length; i ++) {
    if (actionConfig[actionsFlow[i].action] && actionConfig[actionsFlow[i].action].required) {
      console.log(actionConfig[actionsFlow[i].action], actionConfig)
      return actionsFlow[i]
    }
  }
  return null;
};

const isReportActionNeeded = (scope, report) => {
  let nextAction = getReportNextAction(report);

  let actionConfig = report.signFlow[report.type];

  return nextAction
    && actionConfig
    && actionConfig[nextAction.action].required
    && actionConfig[nextAction.action].roles.find(role => role === scope)
};


const hasSignActors = (signFlow, type) => {
  let formSignFlow = signFlow[type];
  return (formSignFlow.approve_one && formSignFlow.approve_one.required)
    || (formSignFlow.approve_two && formSignFlow.approve_two.required)
    || (formSignFlow.approve_three && formSignFlow.approve_three.required)
    || (formSignFlow.approve_four && formSignFlow.approve_four.required)
    || (formSignFlow.approve_five && formSignFlow.approve_five.required)
};

export {
  isReportActionNeeded,
  hasSignActors
}
